<div class="section position-relative">
	<div class="section-top">
		<h3 class="section-title">Unități Administrativ Teritoriale</h3>
		<div class="section-top-actions">
			<button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="rerenderDT(false)">
				<i class="fa-solid fa-arrows-rotate"></i>
			</button>
			<button *ngIf="permissionsService.hasPermission('dgitl-module.settings.unitati-administrativ-teritoriale.add')" type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
				<i class="fa-solid fa-plus"></i>
				Adaugă
			</button>
		</div>
	</div>

	<div class="card-container p-2" *ngIf="showCard">
        <form [formGroup]="searchParamsForm">
            <div class="row">
    
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Denumire</mat-label>
                        <input matInput type="text" formControlName="denumire" />
                    </mat-form-field>
                </div>
                
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" formControlName="email" />
                    </mat-form-field>
                </div>
    
            </div>
            <div class="row">
    
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Telefon</mat-label>
                        <input matInput type="text" formControlName="telefon" />
                    </mat-form-field>
                </div>
                
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Locație</mat-label>
                        <input matInput type="text" formControlName="locatie" />
                    </mat-form-field>
                </div>
    
            </div>
            <div class="row w-100">
                <div class="col d-flex justify-content-start">
                    <button (click)="toggleCard()" type="button" class="btn btn-sm btn-warning closeBtn">Închide</button>
                </div>
                <div class="col buttons-submit">
                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                        Resetează
                    </button>
                    <button (click)="applyFilters()" type="button" class="btn btn-sm btn-primary ms-2">
                        Aplică
                    </button>
                </div>
            </div>
        </form>
	</div>
	<div class="col-sm-12 ps-3">
		<button type="button" class="btn btn-sm btn-default" (click)="toggleCard()" [class.active]="showCard">
			<i class="fa-solid fa-filter"></i> Filtre
		</button>
	</div>
	<div class="table-container">
		<table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100"></table>
	</div>
	<div class="section-spinner position-absolute" *ngIf="isLoading">
		<div class="spinner position-absolute top-50 start-50 translate-middle">
			<mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
		</div>
	</div>
</div>